var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClosePopup({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 18,
    viewBox: "0 0 12 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.2734 5.55859L7.58203 9.25L11.2734 12.9766C11.7305 13.3984 11.7305 14.1367 11.2734 14.5586C10.8516 15.0156 10.1133 15.0156 9.69141 14.5586L6 10.8672L2.27344 14.5586C1.85156 15.0156 1.11328 15.0156 0.691406 14.5586C0.234375 14.1367 0.234375 13.3984 0.691406 12.9766L4.38281 9.25L0.691406 5.55859C0.234375 5.13672 0.234375 4.39844 0.691406 3.97656C1.11328 3.51953 1.85156 3.51953 2.27344 3.97656L6 7.66797L9.69141 3.97656C10.1133 3.51953 10.8516 3.51953 11.2734 3.97656C11.7305 4.39844 11.7305 5.13672 11.2734 5.55859Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClosePopup);
export default __webpack_public_path__ + "static/media/close-popup.fd40ffe71328b0a9f9b4aaf6be897ebe.svg";
export { ForwardRef as ReactComponent };